import { ArrowUpRight } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getWhatsAppUrl } from "@/lib/contactLinks";
import { WhatsAppMark } from "./ContactMarks";
import { trackWhatsAppClick } from "@/lib/analytics";

export default function FloatingContactActions() {
  const location = useLocation();
  const waUrl = getWhatsAppUrl(location.pathname);
  return (
    <div
      className="fixed bottom-4 right-4 z-40 sm:bottom-6 sm:right-6"
      data-testid="floating-contact-actions"
    >
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex items-center gap-3 rounded-full border border-[#214437] bg-[#0A1110]/94 px-3 py-3 shadow-[0_18px_42px_rgba(0,0,0,0.24)] backdrop-blur-md transition-[transform,border-color] duration-300 hover:-translate-y-0.5 hover:border-[#2f6a54] sm:px-4"
        data-testid="floating-whatsapp-link"
        aria-label="Chat on WhatsApp"
        onClick={() => trackWhatsAppClick(location.pathname)}
      >
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#25D366]/14 text-[#63e099]">
          <WhatsAppMark className="h-4 w-4" />
        </span>
        <span className="hidden min-w-0 sm:block">
          <span className="block text-[10px] uppercase tracking-[0.18em] text-brand-text-secondary/50">
            Fastest contact
          </span>
          <span className="block text-[13px] font-medium text-brand-text">
            WhatsApp chat
          </span>
        </span>
        <ArrowUpRight
          size={14}
          className="text-brand-gold transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </a>
    </div>
  );
}
